/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { LinkSelectContext } from "cms/links/link-selector/context/select";
import { formatDate } from "utils/date-format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "cms/icons";
import cn from "classnames";

const {
    faArrowUpRightFromSquare,
    faEnvelope,
    faFile,
    faPlug
} = regular;

const SelectGalleryItem = (props) => {
    
    const isSelected = props.isSelected;
    const link = props.link;
    const { text, url, updated_at, link_type } = link || {};
    const isMailTo = link_type === "mailto";
    const isIntegration = link_type === "integration";
    const isInternal = link_type === "internal";
    const isExternal = link_type === "external";
    const lastUpdated = formatDate(updated_at);
    
    const {
        setSelectedLink,
        setMode,
        MODES,
    } = useContext(LinkSelectContext);

    const item_stylename = cn("simplicity-link-selector-search-filter-list-item", {
        selected: isSelected
    });

    const icon_stylename = cn("simplicity-link-selector-search-filter-list-item-icon", {
        selected: isSelected
    });
    
    const selectLink = (e, link) => {
        e.stopPropagation();
        setMode(MODES.SELECT_PREVIEW);
        setSelectedLink(link);
    };

    return (
        <>
            <div className={item_stylename}
                onClick={(event) => selectLink(event, link)}
            >
                <div className={icon_stylename}>
                    {isExternal && (
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare}/>
                    )}
                    {isInternal && (
                        <FontAwesomeIcon icon={faFile}/>
                    )}
                    {isIntegration && (
                        <FontAwesomeIcon icon={faPlug}/>
                    )}
                    {isMailTo && (
                        <FontAwesomeIcon icon={faEnvelope}/>
                    )}
                </div>
                
                <div className="simplicity-link-selector-search-filter-list-item-main">
                    <div className="simplicity-link-selector-search-filter-list-item-main-text">
                        {text}
                    </div>
                    <div className="simplicity-link-selector-search-filter-list-item-main-url">
                        {url}
                    </div>
                    <div className="simplicity-link-selector-search-filter-list-item-main-date">
                        Last Updated: {lastUpdated}
                    </div>
                </div>
            </div>
        </>
    );
};
export { SelectGalleryItem };
